import { render, staticRenderFns } from "./PcOms.vue?vue&type=template&id=e33b36d6&scoped=true&"
import script from "./PcOms.vue?vue&type=script&lang=js&"
export * from "./PcOms.vue?vue&type=script&lang=js&"
import style0 from "./PcOms.vue?vue&type=style&index=0&id=e33b36d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33b36d6",
  null
  
)

export default component.exports